// src/pages/frontend_guhso/SignOutPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import './AuthPages.css';
import { useAuth } from '../../contexts/AuthContext';

const SignOutPage = () => {
  const { clearAuth } = useAuth();

  const handleSignOut = (event) => {
    event.preventDefault();
    clearAuth();
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <span className="badge">We&apos;ll Miss You</span>
          <h1>Sign Out Safely</h1>
          <p>
            Signing out revokes your active one-time codes and ends exclusive content access
            on this device. You can sign back in any time with a fresh code.
          </p>
        </div>

        <form onSubmit={handleSignOut} className="auth-form">
          <div className="alert-banner">
            <strong>Reminder:</strong>
            Active streams and download queues will pause once you sign out.
          </div>
          <button className="primary-button" type="submit">
            Sign out from this device
          </button>
          <Link className="link-button" to="/signin">
            Need back in? Request a new code
          </Link>
        </form>
      </div>
    </div>
  );
};

export default SignOutPage;
